import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';

import { trackToFeature } from './utils'

import { VesselPositionModel } from '../models/vessel-position-model';
import { Geometry } from 'ol/geom';

export interface Options {
    trackColor: string;
}

export class VesselTrackLayer
{
    constructor(options?: Options)
    {
        if(options) {
            this.setColors(options.trackColor)
        }
        this._plotTrack = this._plotTrack.bind(this);
    }
    
    get layer()
    {
        return this._layer;
    }

    async initialize()
    {
        this._trackVectorSource = new VectorSource({});
        this._layer = new VectorLayer({source: this._trackVectorSource, visible: true, zIndex: 20});
        this._plotTrack(this._trackColor);
    }

    private _plotTrack(trackColor: string)
    {
        const trackData = VesselPositionModel!.track;

        if(!trackData) {
            return
        }

        const features = trackToFeature(trackData!, trackColor, "Navigated Track")
        this._trackVectorSource!.clear();
        this._trackVectorSource!.addFeatures(features);
    }

    setColors(color: string) {
        this._trackColor = color || this._trackColor;
    }
    

    private _layer: VectorLayer<VectorSource<Geometry>>|null = null;
    private _trackVectorSource: VectorSource<Geometry>|null = null;
    private _trackColor: string = "grey";
}